import React, { createContext } from 'react';
import useAsync from '../hooks/useAsync';
import { getSettings, updateSettings } from '../api/settings';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
	const {
		value: settings,
		execute: refreshSettings,
		status: gettingSettings,
	} = useAsync(getSettings);

	const { execute: onUpdateSettings, status: updatingSettings } = useAsync(
		updateSettings,
		{
			immediate: false,
		}
	);

	return (
		<SettingsContext.Provider
			value={{
				settings,
				loading: gettingSettings === 'pending',
				updating: updatingSettings === 'pending',
				update: (payload, opts) =>
					onUpdateSettings(
						payload,
						() => {
							refreshSettings(null, null, {
								silent: true,
								...(opts?.showNotification
									? { showNotification: { success: 'Settings updated' } }
									: {}),
							});
						},
						opts
					),
				refresh: refreshSettings,
			}}
		>
			{children}
		</SettingsContext.Provider>
	);
};

export const SettingsConsumer = SettingsContext.Consumer;

export default SettingsContext;
